export default __webpack_public_path__ + "static/media/IconDesc_Cnr_QuarterPipe_03.256.af114877.png";